/* eslint-disable react/no-unknown-property */
import { useHomeQuery } from '@/queries/home.query';
import { motion } from 'framer-motion';
import { ContainerFluid } from './container/Container';

export default function LogoMitra() {
  // Pakai React Query
  const { data, isLoading, isError } = useHomeQuery();

  // Ambil data partners
  const partners = data?.data?.partners || {};
  const financial = (partners.financial || [])
    .filter((i) => i.is_active)
    .sort((a, b) => a.position - b.position)
    .map((i) => i.logo);

  const nonFinancial = (partners['non-financial'] || [])
    .filter((i) => i.is_active)
    .sort((a, b) => a.position - b.position)
    .map((i) => i.logo);

  if (isLoading) return;
  if (isError) return;

  return (
    <section className="relative py-24 overflow-hidden bg-gradient-to-b from-primary-50/60 to-white">
      {/* === BACKGROUND SHAPES (BNI STYLE) === */}
      <div className="absolute -right-40 top-0 w-[400px] h-[400px] opacity-[0.5]">
        <HalfCircle color="#672178" />
      </div>

      <div className="absolute -left-40 bottom-0 w-[480px] h-[480px] opacity-[0.14]">
        <HalfCircle color="#ffcc00" />
      </div>

      {/* === TEXT HEADER === */}
      <div className="text-center mb-16 relative z-10 px-5">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="text-xs sm:text-sm font-medium leading-relaxed tracking-[0.15em] uppercase text-center text-gray-500"
        >
          Mitra
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-2xl sm:text-3xl md:text-4xl font-semibold leading-snug text-gray-800 mt-2 text-center"
        >
          Berkolaborasi Bersama <br className="lg:hidden" /> Dalam Mendukung <br />
          <span className="text-primary"> Layanan </span> dan
          <span className="text-primary"> Pengembangan </span> Anggota
        </motion.h2>
      </div>

      {/* === GRID SECTIONS (TIDAK DIUBAH) === */}
      <GridMitra title="Mitra Finansial" data={financial} />
      <div className="h-16"></div>
      <GridMitra title="Mitra Non-Finansial" data={nonFinancial} />
    </section>
  );
}

function GridMitra({ title, data }) {
  return (
    <ContainerFluid>
      <div className=" relative z-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
          className="text-xs sm:text-sm font-medium leading-relaxed tracking-[0.15em] uppercase mb-4 text-gray-500"
        >
          {title}
        </motion.p>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-5">
          {data.map((src, idx) => (
            <div
              key={idx}
              className="group relative flex items-center justify-center p-3 rounded-2xl
              border border-gray-200 bg-white shadow-[0_2px_10px_rgba(0,0,0,0.03)]
              hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] hover:scale-[1.03]
              transition-all duration-300 cursor-pointer"
            >
              <div
                className="absolute inset-0 bg-gradient-to-tr from-white/60 via-transparent to-transparent
                opacity-0 group-hover:opacity-60 transition-all duration-500 rounded-2xl z-20"
              />

              <img
                src={src}
                alt={`logo-${idx}`}
                draggable={false}
                onContextMenu={(e) => e.preventDefault()}
                className="h-10 md:h-12 object-contain grayscale opacity-70
                group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300"
                loading="lazy"
                decoding="async"
                fetchpriority={idx === 0 ? 'high' : 'low'}
              />
            </div>
          ))}
        </div>
      </div>
    </ContainerFluid>
  );
}

/* ===== HALFCIRCLE SVG ===== */
function HalfCircle({ color }) {
  return (
    <svg viewBox="0 0 200 200" fill="none">
      <circle cx="100" cy="100" r="100" fill={color} />
    </svg>
  );
}
